import { API_VERSIONS, asinzenAdminApi } from "client/api";

export const getSupplierList = (marketplace: string) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .get(`/${API_VERSIONS}/admin/arbitrage/suppliers/${marketplace}/get-list`);

export const updateSupplierName = (payload: any) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .put(`/${API_VERSIONS}/admin/arbitrage/suppliers/update`, payload);

export const getAllProductListUrls = (marketplace: string) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .get(`/${API_VERSIONS}/admin/arbitrage/product-list-urls/${marketplace}/get-all`);

export const addProductListUrl = (marketplace: string, payload: any) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .post(`/${API_VERSIONS}/admin/arbitrage/product-list-urls/${marketplace}/add`, payload);

export const deleteProductListUrl = (id: string, marketplace: string) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .delete(`/${API_VERSIONS}/admin/arbitrage/product-list-urls/${marketplace}/${id}/delete`);

export const updateProductListUrl = (marketplace: string, payload: any) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .put(`/${API_VERSIONS}/admin/arbitrage/product-list-urls/${marketplace}/update`, payload);

export const getProductSelectorList = (marketplace: string) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .get(`/${API_VERSIONS}/admin/arbitrage/selectors/${marketplace}/get-all`);

export const getProductSelectorListBySupplier = (marketplace: string, supplier: string) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .get(`/${API_VERSIONS}/admin/arbitrage/selectors/${marketplace}/get-all/${supplier}`);

export const updateProductSelector = (marketplace: string, payload: any) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .post(`/${API_VERSIONS}/admin/arbitrage/selectors/${marketplace}/update`, payload);

export const deleteProductSelector = (id: string, marketplace: string) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .delete(`/${API_VERSIONS}/admin/arbitrage/selectors/${marketplace}/${id}/delete`);